/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import { provideLocalizationService as p, registerForLocalization as d } from "@progress/kendo-react-intl";
import { pagerItemPerPage as g, messages as l, pagerPageSizeAriaLabel as r } from "../messages/index.mjs";
import { DropDownList as f } from "@progress/kendo-react-dropdowns";
class z extends s.Component {
  constructor() {
    super(...arguments), this.pageSizeChange = (e) => {
      this.props.pageChange && this.props.pageChange({ skip: 0, take: parseInt(e.target.value, 10) }, e);
    };
  }
  render() {
    const { value: e, pageSizes: m, pageSize: t, messagesMap: a, size: c, navigatable: u } = this.props, i = m.slice();
    e === void 0 && i.filter((h) => h === t).length === 0 && i.unshift(t);
    const n = a ? a(g) : { messageKey: g, defaultMessage: l[g] }, o = a ? a(r) : { messageKey: r, defaultMessage: l[r] };
    return /* @__PURE__ */ s.createElement("span", { className: "k-pager-sizes" }, /* @__PURE__ */ s.createElement(
      f,
      {
        value: e !== void 0 ? e : t,
        data: i,
        onChange: this.pageSizeChange,
        ariaLabel: p(this).toLanguageString(o.messageKey, o.defaultMessage),
        size: c,
        tabIndex: u ? -1 : void 0
      }
    ), /* @__PURE__ */ s.createElement("span", null, p(this).toLanguageString(n.messageKey, n.defaultMessage)));
  }
}
d(z);
export {
  z as PagerPageSizes
};
